import { render, staticRenderFns } from "./WeaponList.vue?vue&type=template&id=058320a4&lang=pug"
import script from "./WeaponList.vue?vue&type=script&lang=js"
export * from "./WeaponList.vue?vue&type=script&lang=js"
import style0 from "./WeaponList.vue?vue&type=style&index=0&id=058320a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports